<template>
  <table class="table-convert" :style="{ fontSize: `${fontSize}px`, width: `${tableWidth}px` }">
    <!--初期表示-->
    <tr v-if="loadConvert === 0" v-scroll="handleScroll">
      <td colspan="2" class="td-load td-load--init" @click="onClickGetConvert()">
        <i-spin fix>
          <i-icon type="ios-loading" size="18" class="spin-icon-load"></i-icon>
          <div>
            ここをクリックするか、画面を下にスクロールしてください
          </div>
        </i-spin>
      </td>
    </tr>

    <!--データ読み込み中-->
    <tr v-if="loadConvert === 1">
      <td colspan="2" class="td-load td-load--loading">
        <i-spin fix>
          <i-icon type="ios-loading" size="18" class="spin-icon-load"></i-icon>
          <div>
            Now Loading...
          </div>
        </i-spin>
      </td>
    </tr>

    <!--エラー データ読み込み失敗-->
    <tr v-if="loadConvert === 9">
      <td colspan="2" class="td-load td-load--error">
        <i-icon type="ios-alert" size="18" class></i-icon>
        <div>Error</div>
      </td>
    </tr>

    <tr v-if="loadConvert === 2 && convert.length === 0">
      <td colspan="2" class="td-load td-load--no-data">
        <div>検索条件に一致するコンバートデータが存在しません。</div>
      </td>
    </tr>

    <!--データ表示-->
    <template v-if="loadConvert === 2 && convert.length > 0">
      <tr v-for="(item, idx) in convert" :key="idx" class="line_convert">
        <td class="shop_name">{{ item.shop_name }}</td>
        <td class="convert-list">
          <div v-for="(status, statusIdx) in item.status" :key="statusIdx" class="button_wrap">
            <template v-if="status.portal_site_cd === 'suumo'">
              <i-tooltip :content="status.updated_at" placement="top" :disabled="!status.updated_at">
                <BtnPanoramaConvert
                  :id="id"
                  :item="item"
                  :status="status"
                  @convert="onClickConvertStatus"
                  @panorama="onClickPanoramaStatus"
                />
              </i-tooltip>
            </template>
            <template v-else>
              <i-tooltip :content="status.updated_at" placement="top" :disabled="!status.updated_at">
                <BtnConvert :id="id" :item="item" :status="status" @convert="onClickConvertStatus" />
              </i-tooltip>
            </template>
          </div>
        </td>
      </tr>
    </template>
  </table>
</template>

<script>
import { Spin, Icon, Tooltip } from 'view-design'
import BtnConvert from '@/components/parts/BtnConvert'
import BtnPanoramaConvert from '@/components/parts/BtnPanoramaConvert'
import BukkenRepository from '@/repositories/bukkenRepository'
export default {
  components: {
    'i-spin': Spin,
    'i-icon': Icon,
    'i-tooltip': Tooltip,
    BtnPanoramaConvert,
    BtnConvert,
  },
  props: {
    id: {
      type: Number,
      default: null,
      required: true,
    },
    convert: {
      type: Array,
      default: () => [],
      required: true,
    },
    loadConvert: {
      type: Number,
      default: 0,
      required: true,
    },
    fontSize: {
      type: Number,
      default: 12,
      required: true,
    },
  },
  data() {
    return {
      height: window.innerHeight,
    }
  },
  computed: {
    _loadConvert: {
      get() {
        return this.loadConvert
      },
      set(val) {
        this.$emit('update:loadConvert', val)
      },
    },
    _convert: {
      get() {
        return this.convert
      },
      set(val) {
        this.$emit('update:convert', val)
      },
    },
    process: {
      get() {
        return this.$store.getters['ConvertProcess/getProcess']
      },
      set(val) {
        this.$store.commit('ConvertProcess/setProcess', val)
      },
    },
    maxProcess() {
      return this.$store.getters['ConvertProcess/getMaxProcess']
    },
    tableWidth() {
      return this.$store.getters['Column/getTableWidth']
    },
  },
  methods: {
    // スクロールを監視し、必要に応じてコンバート情報を取得する
    handleScroll(evt, el) {
      if (this.loadConvert === 0 && this.process <= this.maxProcess) {
        const height = this.height
        const rectTop = el.getBoundingClientRect().y
        const rectBottom = rectTop + el.offsetHeight
        if (height >= rectBottom && rectTop >= 0) {
          this.getConvert(true)
        }
      }
    },
    // コンバートデータ取得処理
    async getConvert(isProcess = false) {
      this._loadConvert = 1
      if (isProcess) this.process += 1
      await BukkenRepository.getConvert(this.id)
        .then(resp => {
          if (resp.result) {
            this._convert = resp.data[this.id]
            this._loadConvert = 2
          } else {
            this._loadConvert = 9
          }
        })
        .catch(e => {
          console.log(e)
          this._loadConvert = 9
        })
        .finally(() => {
          if (isProcess) this.process -= 1
        })
    },
    // コンバート情報取得
    async onClickGetConvert() {
      this.getConvert()
    },
    // コンバートステータス更新処理
    async onClickConvertStatus(id, shopId, siteCd, state, viewOnly, status) {
      // 送信中 / 削除処理中 / 閲覧のみ / 自動送信 は指示不可
      // @notice 高速送信サイトは送信完了時の自動更新が失敗しうるため、手動でのステータス切り替えを許可する
      if (state == 'sending' || state == 'deleting' || viewOnly || status.f_auto_conv) return

      status.loading = true
      await BukkenRepository.putConvert(id, shopId, siteCd, state)
        .then(resp => {
          if (resp.result) {
            const data = resp.data
            status.state = data.new_state
            status.error = false
          } else {
            status.error = true
            this.$store.dispatch('ModalConvertError/set', {})
            this.$store.commit('ModalConvertError/setModal', true)
          }
        })
        .catch(e => {
          console.log(e)
          status.error = true
          const res = e.response
          if (res && res.status === 422) {
            const body = res.data.body
            const data = body.data

            // @notice 他端末での更新を検知した場合は、返ってきた実際の状態にボタンを合わせる
            if (data.new_state) status.state = data.new_state

            const errorObj = {
              b_info: {
                id: data.b_regular_id,
                b_name: data.b_name,
                shop_name: data.shop_name,
              },
              portal_site: data.portal_site_name,
              title: body.message,
              contents: data.problems,
            }
            this.$store.dispatch('ModalConvertError/set', errorObj)
            this.$store.commit('ModalConvertError/setModal', true)
          } else {
            this.$store.dispatch('ModalConvertError/set', {})
            this.$store.commit('ModalConvertError/setModal', true)
          }
        })
        .finally(() => {
          // ボタンのローディングを無効化
          status.loading = false
        })
    },
    // パノラマフラグ 更新処理
    async onClickPanoramaStatus(id, shopId, site, panoramaFlag, status) {
      const flag = panoramaFlag ? 1 : 0
      await BukkenRepository.putConvertPanorama(id, shopId, site, flag)
        .then(resp => {
          if (!resp.result) {
            status.panorama_flag = !panoramaFlag
            alert('データ更新に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          // flagを元に戻す
          status.panorama_flag = !panoramaFlag
          alert('データ更新に失敗しました。')
        })
        .finally(() => {})
    },
  },
}
</script>

<style lang="scss">
.table-convert {
  // 物件テーブル 基本定義
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  margin-bottom: 16px;
  border: 1px solid #cfcfcf;
  border-top: none;

  .line_convert {
    background-color: #fff;
    transition: ease 0.3s;
    &:hover {
      // 物件テーブル コンバートtr hover色
      background-color: #ebf7ff;
      transition: ease 0.3s;
    }
  }

  // テーブル選択時
  &.is-active {
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
  }

  th,
  td {
    vertical-align: middle;
    padding: 2px;
    transition: ease 0.3s;
  }

  td {
    &.shop_name {
      width: 108px;
      vertical-align: middle;
      text-align: center;
      padding: 2px;
      font-weight: bold;
      border: 1px solid #cfcfcf;
      border-top: none;
    }
    &.convert-list {
      text-align: left;
      padding-bottom: 0;
      border: 1px solid #cfcfcf;
      border-top: none;
      .button_wrap {
        display: inline-block;
        margin-right: 4px;
      }
      .ivu-btn {
        margin-right: 4px;
        margin-bottom: 4px;
      }
    }
  }

  // コンバートリスト表示領域
  .td-load {
    position: relative;
    height: 64px;
    text-align: center;
    background-color: #fff;
    &--init {
      // 初期表示
      cursor: pointer;
      .ivu-spin-fix {
        transition: ease 0.5s;
      }
      &:hover .ivu-spin-fix {
        transition: ease 0.5s;
        background-color: #fafafa;
      }
    }
    // ローディング中
    &--loading {
    }
    // エラー表示
    &--error {
      color: #ff0000;
    }
    // no data
    &--no-data {
      font-size: 11px;
    }
  }
}
</style>
